// 登录态清理的唯一出口。
//
// 登录时写入下列 key（见 loginPage.vue 的 handleSubmit）。任何"登出"路径
// ——主动点退出、收到 401 自动登出——都应整组清掉，避免只删 token 而
// 留下 userId / userRole 等身份残留。
//
// 注意：rememberUser（"记住账号"）不属于登录态，刻意不在此清除。
//
// TODO(refactor 规范 17): 后续 token / userId 的"读"与"写"也应收敛到本文件
//   （getToken/setToken/getUser/getRole），届时 loginPage、请求拦截器、路由守卫
//   统一走这里，不再各自 localStorage.getItem('token')。

export const AUTH_KEYS = [
  'token',
  'userId',
  'parentID',
  'tenantOwnerId',
  'uiProfile',
  'userRole',
  'userEmail',
  'userName',
  'latestAlarms',
];

export function getToken() {
  return localStorage.getItem('token') || '';
}

export function getUserId() {
  return Number(localStorage.getItem('userId') || 0);
}

export function getUsername() {
  return localStorage.getItem('userName') || '当前用户';
}

export function getRole() {
  return localStorage.getItem('userRole') || 'user';
}

export function getParentId() {
  return Number(localStorage.getItem('parentID') || 0);
}

export function getTenantOwnerId() {
  return Number(localStorage.getItem('tenantOwnerId') || 0);
}

export function getUIProfile() {
  return localStorage.getItem('uiProfile') || '';
}

export function isManager() {
  return getRole() === 'super_admin' || getRole() === 'admin';
}

export function setAuth(payload, fallbackUsername = '') {
  localStorage.setItem('token', payload.token || '');
  localStorage.setItem('userId', payload.user_id || 0);
  localStorage.setItem('parentID', payload.parent_id || 0);
  localStorage.setItem('tenantOwnerId', payload.tenant_owner_id || payload.user_id || 0);
  localStorage.setItem('uiProfile', payload.ui_profile || '');
  localStorage.setItem('userRole', payload.role || 'user');
  localStorage.setItem('userEmail', payload.email || '');
  localStorage.setItem('userName', fallbackUsername || payload.username || '当前用户');
}

// 清除全部登录态。
export function clearAuth() {
  AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
  window.dispatchEvent(new CustomEvent('yt:auth-cleared'));
}
